import styled, { css } from 'styled-components'

import { PageBlock } from 'components/layout'
import mediaQueries from 'components/media-queries'

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: inline-block;
  flex-direction: column;
  align-items: center;
  width: 100%;
  z-index: 1000;
`

export const SearchboxWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grayLighter};
  height: 0;
  overflow: hidden;
  ${props =>
    props.isExpanded &&
    `
    height: 100%;
    overflow: visible
   `};
`

export const Content = styled(PageBlock)`
  display: flex;
  visibility: hidden;
  height: 0;
  opacity: 0;
  transition: all 500ms ease-in-out;
  background-color: ${({ theme }) => theme.colors.grayLighter};
  box-shadow: 0 1px 1px 0 ${({ theme }) => theme.shadow.black06};
  z-index: -100;
  position: absolute;

  ${props =>
    props.isExpanded &&
    css`
      visibility: visible;
      height: auto;
      opacity: 1;
      z-index: 100;
      padding: 20px 0;

      ${mediaQueries.tablet`
      padding: 20px 60px;
    `} ${mediaQueries.mobile`
      padding: 20px;
    `};
    `};
`

export const UnavailableFlightDateErrorContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.yellowLight};
  min-height: 65px;
  width: 100%;
  margin-bottom: 40px;
  padding: 10px 10px 10px 30px;
  align-items: center;
  display: flex;
  ${mediaQueries.tablet`
    margin-bottom: 0;
  `};
  ${mediaQueries.mobile`
      padding: 10px;
  `};
`

export const ErrorTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  color: ${({ theme }) => theme.colors.doveGrayer};
`

export const ErrorTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  ${mediaQueries.mobile`
    font-size: 14px;
  `};
`

export const ErrorText = styled.div`
  font-family: ${({ theme }) => theme.fonts.regular};
  ${({ style }) => style}
  ${mediaQueries.mobile`
    font-size: 14px;
  `};
`
